import { Quote } from '@client/model/quotesModel';

/**
 * Linearly adjusts a quote's parameters based on a new premium amount
 * All parameters scale proportionally with the premium change
 */
export const adjustQuoteForPremium = (
  originalQuote: Quote,
  newPremiumAmount: number
): Quote => {

  if (!originalQuote.premiumAmount || originalQuote.premiumAmount <= 0) {
    return originalQuote;
  }

  // Calculate the scaling factor
  const scalingFactor = newPremiumAmount / originalQuote.premiumAmount;

  const adjustedQuote: Quote = {
    ...originalQuote,
    premiumAmount: newPremiumAmount,
    
    deathBenefitInitial: originalQuote.deathBenefitInitial * scalingFactor,
    deathBenefitMinimumGuaranteedIndividual: originalQuote.deathBenefitMinimumGuaranteedIndividual
      ? originalQuote.deathBenefitMinimumGuaranteedIndividual * scalingFactor
      : undefined,
    deathBenefitMinimumGuaranteedJoint: originalQuote.deathBenefitMinimumGuaranteedJoint
      ? originalQuote.deathBenefitMinimumGuaranteedJoint * scalingFactor
      : undefined,
    
    ltcBenefitMonthlyIndividual: originalQuote.ltcBenefitMonthlyIndividual * scalingFactor,
    ltcBenefitAnnualIndividual: originalQuote.ltcBenefitAnnualIndividual
      ? originalQuote.ltcBenefitAnnualIndividual * scalingFactor
      : undefined,
    ltcBenefitTotal: originalQuote.ltcBenefitTotal * scalingFactor,

    // Params that stay the same (months and max-min investment don't scale with premium)
    ltcBenefitDurationMonths: originalQuote.ltcBenefitDurationMonths,
    investmentMin: originalQuote.investmentMin,
    investmentMax: originalQuote.investmentMax,

    // Clear any calculated values that need to be recalculated
    projectedCostCoverage: undefined,
    roi: undefined,
    roiValues: undefined,
    formattedROI: undefined,
  };

  return adjustedQuote;
};

/**
 * Adjusts all quotes in an array for a new premium amount
 */
export const adjustQuotesForPremium = (
  originalQuotes: Quote[],
  newPremiumAmount: number
): Quote[] => {
  return originalQuotes.map(quote => adjustQuoteForPremium(quote, newPremiumAmount));
};
